import React from "react";

export const useReOrderDraggableList = ({
  listItems = [],
  serialNumberInitials = "SN",
  disableSN = false,
}) => {
  const [orderedList, setOrderedList] = React.useState(listItems);

  // methods
  const handleOnDragEnd = (dragResult) => {
    const { destination, source, draggableId } = dragResult;

    if (!destination) return;
    if (
      destination.droppableId === source?.droppableId &&
      destination.index === source.index
    )
      return;

    const draggedItem = listItems.find((el) => el._id === draggableId);

    const _tempListItems = [...orderedList];
    _tempListItems.splice(source.index, 1);
    _tempListItems.splice(destination.index, 0, draggedItem);

    // overriding serial numbers
    const reOrderedList = _tempListItems?.map((el, index) => ({
      ...el,
      serialNumber: !disableSN
        ? `${serialNumberInitials}-${index + 1}`
        : index + 1,
    }));

    setOrderedList(reOrderedList);
  };

  React.useEffect(() => {
    const _collatorInstance = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: "base",
    });

    const _alphaNumericSorted =
      [...listItems].sort(({ serialNumber: snA }, { serialNumber: snB }) => {
        return _collatorInstance.compare(snA, snB) > 0 ? 1 : -1;
      }) ?? [];

    setOrderedList([..._alphaNumericSorted]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listItems]);

  return { orderedList, handleOnDragEnd };
};
